import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import OpportunitiesListEmpty from 'opportunities/components/OpportunitiesListEmpty'
import { observer } from 'mobx-react'
import * as React from 'react'
import WorkspacePostingOpportunitiesViewModel from '../../WorkspacePostingOpportunitiesViewModel'
import WorkspaceOpportunityListItem from './WorkspaceOpportunityListItem'

interface OpportunitiesListProps {
  vm: WorkspacePostingOpportunitiesViewModel
}

export default observer(function OpportunitiesList({
  vm,
}: OpportunitiesListProps) {
  return (
    <div>
      <div>
        {vm.opportunities.map((op) => (
          <WorkspaceOpportunityListItem
            key={op.opportunityId}
            opportunity={op}
            detailsVM={vm.detailsVM}
          />
        ))}
        {!vm.searcher.scroller.fetch.pending &&
          vm.opportunities.length === 0 &&
          vm.searcher.scroller.isDone && <OpportunitiesEmpty />}
      </div>
      <InfiniteScrollLoader scrollProvider={vm.searcher.scroller} />
    </div>
  )
})

const OpportunitiesEmpty = observer(function OpportunitiesEmpty() {
  return (
    <OpportunitiesListEmpty
      title="Looking a little empty?"
      imageSrc={require('assets/images/img_empty.svg')}
      subtitle={<>Check back again soon for more potential opportunities.</>}
    ></OpportunitiesListEmpty>
  )
})
